import template from './swag-migration-settings-icon.html.twig';
import './swag-migration-settings-icon.scss';

const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.register('swag-migration-settings-icon', {
    template,
    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    },
});
